// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './admin/Login';
import Dashboard from './admin/App';
import Student from './student/App';
import Faculty from './faculty/App'
import FacultyLogin from './faculty/loginForm'
import Mentor from './mentor/App'
import MentorLogin from './mentor/loginForm'
import ProtectedRoute from '../src/utlis/protectedRoute';
import ProtectedFroute from '../src/utlis/protectedFroute';
import ProtectedMroute from '../src/utlis/protectedMroute';
import PaymentSuccess from './common/pages/paymentSuccess';
import PaymentError from './common/pages/paymentError';
import InternalPaymentError from './common/pages/internalPaymentError';
import PaymentPending from './common/pages/paymentPending';
import Referrer from './referrer/App';
import Error404 from './common/pages/404';
import VMFWidget from './leadsquaredForms/VMFWidget';
import EliteReferralWidget from './leadsquaredForms/EliteReferralWidget';
import StudentReferralForm from './leadsquaredForms/StudentReferralForm';
import NetworkingReferralForm from './leadsquaredForms/NetworkingReferralForm';

const App = () => {

  const token = localStorage.getItem('token');
  const fToken = localStorage.getItem('ftoken');
  const mToken = localStorage.getItem('mtoken');

  return (
    <Router>
      <Routes>
        <Route
          path="/dashboard/*"
          element={<ProtectedRoute element={<Dashboard />} />}
        />
        <Route path="/admin" element={token ? (<Navigate replace to={'/dashboard'} />) : (<Login />)} />
        <Route path="/student/*" element={<Student />} />

        <Route
          path="/faculty/*"
          element={<ProtectedFroute element={<Faculty />} />}
        />
        <Route path="/faculty-login" element={fToken ? (<Navigate replace to={'/faculty/home'} />) : (<FacultyLogin />)} />
        
        <Route
          path="/mentor/*"
          element={<ProtectedMroute element={<Mentor />} />}
        />
        <Route path="/mentor-login" element={mToken ? (<Navigate replace to={'/mentor/home'} />) : (<MentorLogin />)} />

        <Route path="/" element={<Navigate to="/student" />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-error" element={<PaymentError />} />
        <Route path="/payment-pending" element={<PaymentPending />} />
        <Route path="/internal-payment-error" element={<InternalPaymentError />} />

        <Route path="/referrer/*" element={<Referrer />} />

        <Route path="/error-404" element={<Error404 />} />
        <Route path="/visitors-management-form" element={<VMFWidget />} />
        <Route path="/elite-referral-form" element={<EliteReferralWidget />} />
        <Route path="/student-referral-form" element={<StudentReferralForm />} />
        <Route path="/networking-feferral-form" element={<NetworkingReferralForm />} />
      </Routes>
    </Router>
  );
};

export default App;
